<template>
  <div class="product-contact-selector">
    <div class="step-heading">
      {{ labels.get("Looking for product contacts") }}
    </div>
    <div class="row">
      <RadioButtonGroup class="radios">
        <RadioButton
          :label="labels.get('Contact by product name')"
          v-model="selectedOption"
          :value="1"
        ></RadioButton>
        <RadioButton
          :label="labels.get('Sample by product name')"
          v-model="selectedOption"
          :value="2"
        ></RadioButton>
        <RadioButton
          :label="labels.get('Product Search')"
          v-model="selectedOption"
          :value="4"
        ></RadioButton>
      </RadioButtonGroup>
      <div class="product-search-wrapper">
        <ProductSearch
          v-if="selectedOption === 1"
          @change="onProductSelected"
          key="prodsearch1"
        ></ProductSearch>
        <ProductSearch
          sample-available
          v-if="selectedOption === 2"
          @change="onProductSelected"
          key="prodsearch2"
        ></ProductSearch>
      </div>
    </div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import { RadioButtonGroup, RadioButton } from "clariant-vue3-forms";
import ProductSearch from "./ProductSearch.vue";

export default {
  name: "ProductContactSelector",
  components: {
    RadioButtonGroup,
    RadioButton,
    ProductSearch
  },
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      selectedOption: 0,
      currentProduct: "",
      currentBusinessLine: "",
      currentBusinessUnit: "",
      currentSampleOrderUrl: "",
    };
  },
  watch: {
    currentProduct(val) {
      this.state.current["canAdvance"] = !!val;
    },
    currentBusinessLine(val) {
      this.state.current["canAdvance"] = !!val;
    },
    selectedOption(val) {
      this.currentProduct = "";
      this.currentBusinessUnit = "";
      this.currentBusinessLine = "";
      this.$nextTick(() => {
        this.state.set("canAdvance", val === 4);
      });
    },
  },
  mounted() {},
  methods: {
    getPrevStep() {
      return 0;
    },
    canAdvance() {
      return (
        !!this.currentProduct ||
        !!this.currentBusinessLine ||
        this.selectedOption === 4
      );
    },
    getNextStep() {
      this.updateState();
      if (this.selectedOption === 2) return this.config.jumpToSampleOrder;
      else if (this.selectedOption === 4) return this.config.jumpToProductSearch;
      else return 6;
    },
    onProductSelected(p) {
      this.currentProduct = p.id;
      this.currentBusinessLine = p.businessLineId;
      this.currentBusinessUnit = p.businessUnitId;
      this.currentSampleOrderUrl = p.sampleOrderUrl;
    },
    updateState() {
      let updatedState = null;
      if (this.selectedOption === 1) {
        updatedState = {
          bu: this.currentBusinessUnit,
          bl: this.currentBusinessLine,
          currentContact: "",
          currentProduct: this.currentProduct,
          currentSampleOrderUrl: ""
        };
      } else if (this.selectedOption === 2) {
        updatedState = {
          bu: this.currentBusinessUnit,
          bl: this.currentBusinessLine,
          currentContact: "",
          currentProduct: this.currentProduct,
          currentSampleOrderUrl: this.currentSampleOrderUrl
        };
      } else if (this.selectedOption === 3) {
        updatedState = {
          bu: "",
          bl: this.currentBusinessLine,
          currentContact: "",
          currentProduct: "",
          currentSampleOrderUrl: ""
        };
      }

      if (updatedState) {
        this.state.atomicUpdate("reload", updatedState);
      }
    },
  },
};
</script>

<style scoped>
.cla-radio {
    margin: 17px 0 !important;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.row > * {
  width: 50%;
}

@media all and (max-width: 700px) {
    .row {
        flex-direction: column;
        align-items: flex-start;
    }
    .row > * {
        width: 100%;
    }
}

</style>
